module.exports = __webpack_public_path__ + "media/img/pages/companies/bystronic-83636c96635676019c4e8ad81845a834.png";